import { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Button } from "antd";
import firebase from "firebase/app";
import "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import Countdown from 'react-countdown';
import { EMAIL_VERIFIED_SUCCESS, LOGOUT_USER_REQUEST, CREATE_BOOKING_REQUEST, CHNAGE_LANGUAGE } from "../../redux/constants";
import { getBookingState, getAppState } from "../../redux/selectors";
import { ContentRow, FormCol, FormButton } from "../../components/GlobalStyles";
import Logo from "../../assets/images/setpoint-logo.png";

export function EmailVerify(): ReactElement {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isEmailSent, setEmailSent] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [showCounter, setShowCounter] = useState<boolean>(false);
  const { isShareBooking, shareBookingTime, shareBookingDuration, shareBookingCourt, preBranch, preBookingDate } = useSelector(getBookingState);
  const { t, i18n } = useTranslation();
  const { locale } = useSelector(getAppState);

  useEffect(() => {
    const authUser = firebase.auth().currentUser;
    const intervalHandler = setInterval(() => {
      authUser?.reload();
      if (authUser?.emailVerified) {
        clearInterval(intervalHandler);
        firebase.firestore().collection("users").doc(authUser.uid).update({ emailVerified: true });
        dispatch({
          type: EMAIL_VERIFIED_SUCCESS,
          payload: {},
        });
        if (isShareBooking) {
          // Create new booking with Share data
          const newBooking = {
            bookingId: uuidv4(),
            userId: authUser?.uid,
            branchId: preBranch?.branchId,
            courtId: shareBookingCourt,
            date: preBookingDate,
            period: shareBookingDuration,
            start: shareBookingTime,
            end: "",
            ball: false,
            club: preBranch?.clubData.clubId,
            price: preBranch?.clubData.price[shareBookingDuration],
            currency: preBranch?.clubData.currency,
            careteAt: firebase.firestore.FieldValue.serverTimestamp(),
          };
          dispatch({
            type: CREATE_BOOKING_REQUEST,
            payload: { data: newBooking }
          });
        }
        setTimeout(() => {
          window.location.replace("/booking");
        }, 2000)
      }
    }, 5000);
  }, []);

  const sendEmailVerification = () => {
    const authUser = firebase.auth().currentUser;
    authUser?.sendEmailVerification()
      .then(() => {
        setError(false);
        setEmailSent(true);
      })
      .catch((e) => {
        console.log(e);
        setEmailSent(false);
        setError(true);
        setShowCounter(true);
      });
  };

  const logout = () => {
    firebase.auth().signOut();
    dispatch({ type: LOGOUT_USER_REQUEST });
    history.push("/login");
  };

  const renderer = ({ hours, minutes, seconds, completed }: any) => {
    if (completed) {
      // Render a completed state
      return <span>done</span>;
    }
    return <p className="error">You can send new verification email after <span>{minutes} mins {seconds} seconds</span></p>;
  };

  const onChangeLanguage = (code: string) => {
    dispatch({
      type: CHNAGE_LANGUAGE,
      payload: code
    })
    i18n.changeLanguage(code);
  }



  return (
    <ContentRow className="auth-container">
      <div className="landing-language-select-container">
        <Button className="language-selector" onClick={() => onChangeLanguage(locale === "en" ? "ar" : "en")}>{t("common.language")}</Button>
      </div>
      <Card className="auth-form">
        <FormCol span={24}>
          <img src={Logo} alt="Logo" style={{ width: 150, marginBottom: 30 }} />
          <p style={{ color: "#fff" }}>{t("auth.notification_for_verify_email_sent")}</p>
        </FormCol>
        <FormButton type="primary" block onClick={sendEmailVerification} disabled={showCounter}>
          {t("auth.resend_verification_email")}
        </FormButton>
        <FormButton type="primary" block onClick={logout}>
          {t("auth.use_another_account")}
        </FormButton>
        {showCounter && <Countdown
          date={Date.now() + 120000}
          renderer={renderer}
          onComplete={() => setShowCounter(false)}
        />}
        {/* {error && <p className="error">Sorry, something went wrong!</p>} */}
        {isEmailSent && (
          <p className="success">{`Verification email has been sent to 
          ${firebase.auth().currentUser?.email}.`}</p>
        )}
      </Card>
      <div className="contact-us-container">
        <span>{t("menu.contact_us")}: </span>
        <a href="mailto:hi@setpointapp.com" target="_blank" rel="noreferrer">hi@setpointapp.com</a>
      </div>
    </ContentRow>
  );
}
